import usePluginEntities from "hooks/usePluginEntities";
import OpenSourceUpsellWrapper from "components/upsell/OpenSourceUpsellWrapper";
const usePluggableUpsellWrapper = () => {
  var _a, _b;
  const upsellWrapper = usePluginEntities("components.upsell.wrapper");
  if (!((_b = (_a = upsellWrapper == null ? void 0 : upsellWrapper[0]) == null ? void 0 : _a.useCondition) == null ? void 0 : _b.call(_a))) {
    return OpenSourceUpsellWrapper;
  }
  return upsellWrapper[0].component;
};
export default usePluggableUpsellWrapper;
